import { makeTable } from "../utils/tables";

export const backgrounds = makeTable("backgrounds", [
  "Moon outlaw",
  "Monolith cultist",
  "Event horizon diver",
  "Technomant",
  "Astrochemist",
  "Interstellar soldier",
  "Orbit vagabond",
  "Gravity swindler",
  "Intergalactic traveler",
  "Legionnaire",
  "Freight tracer",
  "Asteroid driller",
  "Isotope coder",
  "Station marshal",
  "Static noise translator",
  "Asteroid archaeologist",
  "Tow trucker",
  "Star salvager",
  "Bounty hunter",
  "Deep field welder",
]);
